import _Object$keys from '@babel/runtime-corejs3/core-js-stable/object/keys';
import _Object$getOwnPropertySymbols from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols';
import _filterInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/filter';
import _Object$getOwnPropertyDescriptor from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor';
import _forEachInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/for-each';
import _Object$getOwnPropertyDescriptors from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors';
import _Object$defineProperties from '@babel/runtime-corejs3/core-js-stable/object/define-properties';
import _Object$defineProperty from '@babel/runtime-corejs3/core-js-stable/object/define-property';
import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import _bindInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/bind';
import classNames from 'classnames/bind';
import React from 'react';
import './buttons/BenefitButton.js';
import HeaderButton from './HeaderButton.js';
import '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import '@babel/runtime-corejs3/core-js-stable/instance/fill';
import TextButton from './buttons/TextButton.js';
import CommonHeader from './CommonHeader.js';
import CommonHeaderTitle from './CommonHeaderTitle.js';
import IcTopBack from '../icons/IcTopBack.js';
import { hasChildComponent } from '../../utils/react.js';
import styles from './HeaderBack.module.scss.js';

function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context, _context2; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context = ownKeys(Object(t), !0)).call(_context, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context2 = ownKeys(Object(t))).call(_context2, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
var cx = _bindInstanceProperty(classNames).call(classNames, styles);
function BackButton(props) {
  return /*#__PURE__*/React.createElement(HeaderButton, _objectSpread({}, props), /*#__PURE__*/React.createElement(IcTopBack, {
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("span", {
    className: "blind"
  }, "\uB4A4\uB85C\uAC00\uAE30"));
}
/**
 *
 * 뒤로가기가 가능한 화면의 헤더
 */
function HeaderBack(_ref) {
  var title = _ref.title,
    serviceName = _ref.serviceName,
    rightComponent = _ref.rightComponent,
    tooltipIconType = _ref.tooltipIconType,
    onClickTooltip = _ref.onClickTooltip,
    children = _ref.children,
    backButton = _ref.backButton;
  return /*#__PURE__*/React.createElement(CommonHeader, {
    align: "center",
    innerClassName: cx('article', {
      'padding-wide': hasChildComponent({
        children: rightComponent,
        targetComponent: TextButton
      })
    }),
    leftComponent: /*#__PURE__*/React.createElement(BackButton, _objectSpread({}, backButton)),
    rightComponent: rightComponent
  }, /*#__PURE__*/React.createElement("h1", {
    className: "blind"
  }, !!serviceName ? serviceName : '네이버페이'), /*#__PURE__*/React.createElement(CommonHeaderTitle, {
    title: title,
    tooltipIconType: tooltipIconType,
    onClickTooltip: onClickTooltip
  }), children);
}

export { HeaderBack as default };
